/*! proton-sticky-checkout.js — mobile sticky checkout bar on the /cart page.
 * Keeps the Checkout CTA + live subtotal permanently in view so shoppers don't
 * have to scroll past cart line items to convert. Mobile only (<= 749px).
 * Self-contained, no dependencies. Idempotent. Cart-page only.
 * Aesthetic: glass + orange gradient + glow (Proton).
 */
(function () {
  'use strict';
  if (window.__protonStickyCheckout) return;
  window.__protonStickyCheckout = true;

  var TAG = '[proton-sticky-checkout]';
  var MONEY_FMT = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD';

  // Only run on the cart page.
  function onCartPage() {
    return /^\/cart\/?$/.test(location.pathname);
  }
  if (!onCartPage()) { try { console.info(TAG, 'not cart page, idle'); } catch (e) {} return; }

  function money(cents) {
    var n = (cents || 0) / 100;
    try {
      return new Intl.NumberFormat('en-US', { style: 'currency', currency: MONEY_FMT }).format(n);
    } catch (e) {
      return '$' + n.toFixed(2);
    }
  }

  // ---- styles ----
  var css = '' +
    '#pp-sticky-checkout{position:fixed;left:0;right:0;bottom:0;z-index:2147483000;' +
    'transform:translateY(120%);transition:transform .28s cubic-bezier(.22,1,.36,1);' +
    'padding:10px 12px calc(10px + env(safe-area-inset-bottom,0px));' +
    'display:flex;align-items:center;gap:12px;' +
    'background:rgba(17,14,12,.72);backdrop-filter:blur(14px) saturate(140%);' +
    '-webkit-backdrop-filter:blur(14px) saturate(140%);' +
    'border-top:1px solid rgba(255,255,255,.10);' +
    'box-shadow:0 -8px 30px rgba(0,0,0,.35);}' +
    '#pp-sticky-checkout.pp-show{transform:translateY(0);}' +
    '#pp-sticky-checkout .pp-sc-info{display:flex;flex-direction:column;line-height:1.15;min-width:0;}' +
    '#pp-sticky-checkout .pp-sc-label{font-size:11px;letter-spacing:.06em;text-transform:uppercase;' +
    'color:rgba(222,202,164,.85);font-weight:600;}' +
    '#pp-sticky-checkout .pp-sc-total{font-size:19px;font-weight:800;color:#fff;' +
    'font-variant-numeric:tabular-nums;}' +
    '#pp-sticky-checkout .pp-sc-btn{margin-left:auto;flex:0 0 auto;appearance:none;border:0;cursor:pointer;' +
    'display:inline-flex;align-items:center;gap:8px;white-space:nowrap;' +
    'padding:14px 22px;border-radius:14px;font-size:16px;font-weight:800;color:#1a1206;' +
    'background:linear-gradient(135deg,#FFB44D 0%,#FF6000 55%,#F24E00 100%);' +
    'box-shadow:0 6px 22px rgba(255,96,0,.45),inset 0 1px 0 rgba(255,255,255,.35);' +
    'transition:transform .12s ease,box-shadow .2s ease;}' +
    '#pp-sticky-checkout .pp-sc-btn:active{transform:scale(.97);}' +
    '#pp-sticky-checkout .pp-sc-btn[aria-disabled="true"]{opacity:.55;pointer-events:none;}' +
    '#pp-sticky-checkout .pp-sc-arrow{font-size:18px;transform:translateY(-1px);}' +
    '@media (min-width:750px){#pp-sticky-checkout{display:none !important;}}';

  var style = document.createElement('style');
  style.id = 'pp-sticky-checkout-css';
  style.textContent = css;
  document.head.appendChild(style);

  // ---- bar ----
  var bar = document.createElement('div');
  bar.id = 'pp-sticky-checkout';
  bar.setAttribute('role', 'region');
  bar.setAttribute('aria-label', 'Checkout');
  bar.innerHTML =
    '<div class="pp-sc-info">' +
      '<span class="pp-sc-label" id="pp-sc-label">Subtotal</span>' +
      '<span class="pp-sc-total" id="pp-sc-total">—</span>' +
    '</div>' +
    '<button type="button" class="pp-sc-btn" id="pp-sc-btn">' +
      '<span id="pp-sc-btn-text">Checkout</span><span class="pp-sc-arrow">&rarr;</span>' +
    '</button>';
  document.body.appendChild(bar);

  var elTotal = bar.querySelector('#pp-sc-total');
  var elLabel = bar.querySelector('#pp-sc-label');
  var elBtn = bar.querySelector('#pp-sc-btn');
  var elBtnText = bar.querySelector('#pp-sc-btn-text');

  // ---- go to checkout ----
  function goCheckout() {
    // Prefer submitting the real cart form so any theme-side cart notes/attributes persist.
    var native = document.querySelector(
      'button[name="checkout"],input[name="checkout"],[data-checkout-button],.cart__checkout,.cart__checkout-button,#checkout'
    );
    if (native) { try { native.click(); return; } catch (e) {} }
    var form = document.querySelector('form[action^="/cart"],form#cart,form[action*="/cart"]');
    if (form) {
      try {
        var hidden = document.createElement('input');
        hidden.type = 'hidden'; hidden.name = 'checkout'; hidden.value = '';
        form.appendChild(hidden);
        if (typeof form.requestSubmit === 'function') form.requestSubmit(); else form.submit();
        return;
      } catch (e) {}
    }
    window.location.href = '/checkout';
  }
  elBtn.addEventListener('click', goCheckout);

  // ---- subtotal ----
  function render(cart) {
    if (!cart || typeof cart.item_count !== 'number') return;
    if (cart.item_count <= 0) {
      bar.classList.remove('pp-show');
      return;
    }
    elTotal.textContent = money(cart.total_price);
    var n = cart.item_count;
    elLabel.textContent = 'Subtotal · ' + n + ' item' + (n === 1 ? '' : 's');
    elBtnText.textContent = 'Checkout';
    elBtn.setAttribute('aria-disabled', 'false');
    bar.classList.add('pp-show');
  }

  var fetching = false;
  function refresh() {
    if (fetching) return;
    fetching = true;
    fetch('/cart.js', { headers: { 'Accept': 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(render)
      .catch(function (e) { try { console.warn(TAG, 'cart fetch failed', e); } catch (x) {} })
      .then(function () { fetching = false; });
  }

  // Initial paint (slide up shortly after load for a dopaminergic reveal).
  refresh();
  setTimeout(refresh, 400);

  // Keep subtotal fresh as the shopper edits quantities.
  // 1) Theme custom events some Dawn-family themes dispatch.
  ['cart:updated', 'cart:refresh', 'cart:change', 'ajaxCart.afterCartLoad'].forEach(function (ev) {
    document.addEventListener(ev, function () { setTimeout(refresh, 120); });
  });
  document.addEventListener('publish', function () { setTimeout(refresh, 150); });
  // 2) Patch fetch so any /cart/{add,change,update,clear} write triggers a re-read.
  try {
    var origFetch = window.fetch;
    window.fetch = function () {
      var url = '';
      try { url = (arguments[0] && arguments[0].url) || String(arguments[0] || ''); } catch (e) {}
      var p = origFetch.apply(this, arguments);
      if (/\/cart\/(add|change|update|clear)(\.js)?/.test(url)) {
        p.then(function () { setTimeout(refresh, 120); }).catch(function () {});
      }
      return p;
    };
  } catch (e) {}
  // 3) Safety net: any click inside the cart form → re-read after the DOM settles.
  document.addEventListener('click', function (e) {
    if (e.target && e.target.closest && e.target.closest('form[action^="/cart"],form[action*="/cart"],.cart')) {
      setTimeout(refresh, 400);
    }
  }, true);
  // 4) Re-read when tab regains focus (bfcache / back navigation).
  window.addEventListener('pageshow', refresh);
  window.addEventListener('focus', refresh);
})();
